// extracted by mini-css-extract-plugin
module.exports = {"base":"Search_base__h5SF4","input":"Search_input__2lH19","focus":"Search_focus__2lcA0"};